module.exports = __webpack_public_path__ + "img/icon_4.b749edbd.png";